import { postApiGalaxyServer } from 'services';

export interface RefreshTeamIntegrationsPayload {
  teamIds: number[];
}

export const refreshTeamIntegrationsApi = ({
  params,
  token,
  config,
}: BaseApiParams<RefreshTeamIntegrationsPayload>) => {
  return postApiGalaxyServer(`/lookup/team-integrations/refresh`, params, config ?? {}, token);
};
